(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dali-pups-guided-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-guided-order')) {
    customElements.define('dp-guided-order', class extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-dp-panel]')];
        this.progress = this.querySelector('[data-dp-progress]');
        this.progressItems = [...this.querySelectorAll('[data-dp-progress-item]')];
        this.conditionalStep = this.querySelector('[data-dp-conditional-step]');
        this.stepStatus = this.querySelector('[data-dp-step-status]');
        this.productGrid = this.querySelector('[data-dp-product-grid]');
        this.resultCount = this.querySelector('[data-dp-result-count]');
        this.figureNext = this.querySelector('[data-dp-figure-next]');
        this.genderNext = this.querySelector('[data-dp-gender-next]');
        this.sentinel = this.querySelector('[data-dp-sentinel]');
        this.retry = this.querySelector('[data-dp-retry]');
        this.sources = JSON.parse(this.querySelector('[data-dp-sources]').textContent);
        this.stateKey = 'dp-guided-order-state-v2';
        this.count = null;
        this.gender = null;
        this.currentGroup = null;
        this.nextPage = 1;
        this.totalPages = 1;
        this.visibleCount = 0;
        this.isLoading = false;
        this.resultsTracked = false;
        this.loadedHandles = new Set();
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this.sentinel);
        this.querySelectorAll('[data-dp-count]').forEach((button) => button.addEventListener('click', () => this.selectCount(button)));
        this.querySelectorAll('[data-dp-gender]').forEach((button) => button.addEventListener('click', () => this.selectGender(button)));
        this.figureNext.addEventListener('click', () => this.continueFromCount());
        this.genderNext.addEventListener('click', () => this.continueFromGender());
        this.querySelectorAll('[data-dp-back]').forEach((button) => button.addEventListener('click', () => this.goBack()));
        this.querySelectorAll('[data-dp-restart]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.retry.addEventListener('click', () => this.showProducts(this.currentGroup));
        this.productGrid.addEventListener('click', (event) => {
          const card = event.target.closest('[data-dp-product-card]');
          if (!card) return;
          this.track('dp_design_selected', {
            figure_count: Number(this.count),
            style: this.gender || '',
            product_handle: card.dataset.dpProductHandle || '',
            position: [...this.productGrid.querySelectorAll('[data-dp-product-card]')].indexOf(card) + 1
          });
          this.persistState('design');
        });
        const restored = this.restoreState();
        this.updateProgress('figures');
        this.track('dp_order_builder_view', { restored });
        if (restored && this.currentGroup) window.setTimeout(() => this.showProducts(this.currentGroup, false), 0);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
      }

      restoreState() {
        let saved = null;
        try {
          saved = JSON.parse(sessionStorage.getItem(this.stateKey) || 'null');
        } catch (error) {
          saved = null;
        }
        const params = new URLSearchParams(window.location.search);
        const count = params.get('dp_figures') || saved?.count;
        const gender = params.get('dp_style') || saved?.gender;
        if (!count || !this.sources[count === '1' ? gender : count]) return false;
        this.count = String(count);
        this.gender = gender || null;
        this.currentGroup = this.count === '1' ? this.gender : this.count;
        this.querySelector(`[data-dp-count="${this.count}"]`)?.setAttribute('aria-pressed', 'true');
        if (this.gender) this.querySelector(`[data-dp-gender="${this.gender}"]`)?.setAttribute('aria-pressed', 'true');
        this.setContinueState(this.figureNext, true);
        this.setContinueState(this.genderNext, Boolean(this.gender));
        return saved?.step === 'design' || params.get('dp_step') === 'design';
      }

      selectCount(button) {
        this.count = button.dataset.dpCount;
        this.gender = null;
        this.currentGroup = this.count === '1' ? null : this.count;
        this.querySelectorAll('[data-dp-count]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, true);
        this.setContinueState(this.genderNext, false);
        this.persistState('figures');
        this.track('dp_figure_selected', { figure_count: Number(this.count) });
      }

      continueFromCount() {
        if (!this.count) return;
        if (this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
          this.persistState('gender');
        } else {
          this.showProducts(this.count);
        }
      }

      selectGender(button) {
        this.gender = button.dataset.dpGender;
        this.currentGroup = this.gender;
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.setContinueState(this.genderNext, true);
        this.persistState('gender');
        this.track('dp_style_selected', { figure_count: 1, style: this.gender });
      }

      continueFromGender() {
        if (this.gender) this.showProducts(this.gender);
      }

      setContinueState(button, enabled) {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
        button.classList.toggle('is-ready', enabled);
      }

      async showProducts(group, scroll = true) {
        if (!group || !this.sources[group]) return;
        this.abortController?.abort();
        this.currentGroup = group;
        this.nextPage = 1;
        this.totalPages = 1;
        this.visibleCount = 0;
        this.resultsTracked = false;
        this.loadedHandles.clear();
        this.productGrid.replaceChildren();
        this.retry.hidden = true;
        this.showPanel('design', scroll);
        this.updateProgress('design');
        const featuredCount = this.appendFeaturedCards(group);
        if (featuredCount) {
          this.resultCount.textContent = this.dataset.foundTemplate.replace('__COUNT__', this.visibleCount);
        } else {
          this.showSkeletons();
        }
        this.persistState('design');
        await this.loadNextPage();
      }

      appendFeaturedCards(group) {
        const source = this.sources[group];
        const template = [...this.querySelectorAll('[data-dp-featured-group]')]
          .find((item) => item.dataset.dpFeaturedGroup === String(group));
        if (!source || !template) return 0;
        const content = template.content.cloneNode(true);
        let appended = 0;
        [...content.querySelectorAll('[data-dp-product-card]')].forEach((card) => {
          const handle = card.dataset.dpProductHandle;
          if (!handle || this.loadedHandles.has(handle) || !this.matchesFigureCount(card, source.mode)) return;
          this.loadedHandles.add(handle);
          this.decorateCard(card);
          const image = card.querySelector('img');
          if (image && this.visibleCount < 4) {
            image.loading = 'eager';
            image.fetchPriority = 'high';
          }
          this.productGrid.append(card);
          this.visibleCount += 1;
          appended += 1;
        });
        return appended;
      }

      async loadNextPage() {
        if (this.isLoading || !this.currentGroup || this.nextPage > this.totalPages) return;
        const source = this.sources[this.currentGroup];
        const page = this.nextPage;
        this.isLoading = true;
        this.abortController = new AbortController();
        let appended = 0;
        try {
          const url = new URL(source.url, window.location.origin);
          url.searchParams.set('view', 'dp-guided');
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { headers: { Accept: 'text/html' }, signal: this.abortController.signal });
          if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const wrapper = parsed.querySelector('[data-dp-results-page]');
          if (!wrapper) throw new Error('Catalog response is empty');
          this.totalPages = Math.max(1, Number(wrapper.dataset.pages || 1));
          const fragment = document.createDocumentFragment();
          [...wrapper.querySelectorAll('[data-dp-product-card]')].forEach((card) => {
            const handle = card.dataset.dpProductHandle;
            if (!handle || this.loadedHandles.has(handle) || !this.matchesFigureCount(card, source.mode)) return;
            this.loadedHandles.add(handle);
            this.decorateCard(card);
            if (this.visibleCount === 0) card.querySelector('[data-dp-card-popular]').hidden = false;
            const image = card.querySelector('img');
            if (image && this.visibleCount < 4) {
              image.loading = 'eager';
              image.fetchPriority = 'high';
            }
            fragment.append(card);
            this.visibleCount += 1;
            appended += 1;
          });
          this.productGrid.querySelectorAll('.is-skeleton').forEach((item) => item.remove());
          this.productGrid.append(fragment);
          this.nextPage = page + 1;
          this.resultCount.textContent = this.visibleCount
            ? this.dataset.foundTemplate.replace('__COUNT__', this.visibleCount)
            : this.dataset.loadingLabel;
          this.retry.hidden = true;
          if (!this.resultsTracked && this.visibleCount) {
            this.resultsTracked = true;
            this.track('dp_design_results_viewed', {
              figure_count: Number(this.count),
              style: this.gender || '',
              result_count: this.visibleCount,
              source: this.currentGroup
            });
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            if (page === 1) this.productGrid.replaceChildren();
            this.resultCount.textContent = this.dataset.errorLabel;
            this.retry.hidden = false;
          }
          return;
        } finally {
          this.isLoading = false;
        }
        if (!appended && this.nextPage <= this.totalPages) {
          await this.loadNextPage();
        } else if (!this.visibleCount && this.nextPage > this.totalPages) {
          this.resultCount.textContent = this.dataset.emptyLabel;
        }
      }

      matchesFigureCount(card, mode) {
        const tags = String(card.dataset.dpProductTags || '')
          .split('|')
          .map((tag) => tag.normalize('NFKD').replace(/\p{Diacritic}/gu, '').replaceAll('ı', 'i').trim().toLocaleLowerCase('tr'));
        const countTags = ['ikili', 'uclu', 'dortlu', 'besli', 'altili', 'yedili', '7li'];
        if (mode === 'single') return !tags.some((tag) => countTags.includes(tag));
        const wanted = {
          2: ['ikili'],
          3: ['uclu'],
          4: ['dortlu'],
          5: ['besli'],
          6: ['altili'],
          7: ['yedili', '7li']
        };
        return (wanted[mode] || []).some((tag) => tags.includes(tag));
      }

      decorateCard(card) {
        const target = new URL(card.getAttribute('href'), window.location.origin);
        const current = new URLSearchParams(window.location.search);
        current.forEach((value, key) => {
          if (key.startsWith('utm_') || ['gclid', 'fbclid', 'ttclid'].includes(key)) target.searchParams.set(key, value);
        });
        target.searchParams.set('dp_figures', this.count);
        if (this.gender) target.searchParams.set('dp_style', this.gender);
        card.href = target.toString();
      }

      showSkeletons() {
        this.resultCount.textContent = this.dataset.loadingLabel;
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < 6; index += 1) {
          const skeleton = document.createElement('span');
          skeleton.className = 'dp-guided-order__product is-skeleton';
          skeleton.setAttribute('aria-hidden', 'true');
          fragment.append(skeleton);
        }
        this.productGrid.replaceChildren(fragment);
      }

      goBack() {
        this.abortController?.abort();
        const current = this.panels.find((panel) => !panel.hidden)?.dataset.dpPanel;
        if (current === 'design' && this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
          this.persistState('gender');
          return;
        }
        this.showPanel('figures');
        this.updateProgress('figures');
        this.persistState('figures');
      }

      reset() {
        this.abortController?.abort();
        this.count = null;
        this.gender = null;
        this.currentGroup = null;
        this.productGrid.replaceChildren();
        this.querySelectorAll('[aria-pressed]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, false);
        this.setContinueState(this.genderNext, false);
        try { sessionStorage.removeItem(this.stateKey); } catch (error) {}
        const url = new URL(window.location.href);
        ['dp_figures', 'dp_style', 'dp_step'].forEach((key) => url.searchParams.delete(key));
        history.replaceState({}, '', url);
        this.showPanel('figures');
        this.updateProgress('figures');
      }

      persistState(step) {
        const group = this.count === '1' ? this.gender : this.count;
        try {
          sessionStorage.setItem(this.stateKey, JSON.stringify({ count: this.count, gender: this.gender, group, step }));
        } catch (error) {}
        const url = new URL(window.location.href);
        if (this.count) url.searchParams.set('dp_figures', this.count);
        else url.searchParams.delete('dp_figures');
        if (this.gender) url.searchParams.set('dp_style', this.gender);
        else url.searchParams.delete('dp_style');
        if (step === 'design') url.searchParams.set('dp_step', 'design');
        else url.searchParams.delete('dp_step');
        history.replaceState({}, '', url);
      }

      showPanel(name, scroll = true) {
        const update = () => {
          this.panels.forEach((panel) => { panel.hidden = panel.dataset.dpPanel !== name; });
        };
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reduceMotion) document.startViewTransition(update);
        else update();
        if (!scroll) return;
        window.setTimeout(() => {
          this.querySelector(`[data-dp-panel="${name}"] h2`)?.focus({ preventScroll: true });
          this.querySelector('[data-dp-panel]:not([hidden])')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }, reduceMotion ? 0 : 180);
      }

      updateProgress(current) {
        const hasGender = this.count === '1' || this.count === null;
        this.conditionalStep.hidden = !hasGender;
        const visible = this.progressItems.filter((item) => !item.hidden);
        this.progress.style.setProperty('--dp-visible-steps', visible.length);
        const currentIndex = Math.max(0, visible.findIndex((item) => item.dataset.dpProgressItem === current));
        visible.forEach((item, index) => {
          item.classList.toggle('is-complete', index < currentIndex);
          if (index === currentIndex) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
          item.querySelector(':scope > span').textContent = index + 1;
        });
        this.stepStatus.textContent = `${this.dataset.stepWord} ${currentIndex + 1} / ${visible.length}`;
      }

      track(name, detail) {
        document.dispatchEvent(new CustomEvent(name, { detail }));
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish(name, detail);
        }
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
      }
    });
  }

  if (!customElements.get('dp-guided-order')) {
    customElements.define('dp-guided-order', class extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-dp-panel]')];
        this.progress = this.querySelector('[data-dp-progress]');
        this.progressItems = [...this.querySelectorAll('[data-dp-progress-item]')];
        this.conditionalStep = this.querySelector('[data-dp-conditional-step]');
        this.stepStatus = this.querySelector('[data-dp-step-status]');
        this.productGrid = this.querySelector('[data-dp-product-grid]');
        this.resultCount = this.querySelector('[data-dp-result-count]');
        this.figureNext = this.querySelector('[data-dp-figure-next]');
        this.genderNext = this.querySelector('[data-dp-gender-next]');
        this.productTemplate = this.querySelector('[data-dp-product-template]');
        this.sentinel = this.querySelector('[data-dp-sentinel]');
        this.sources = JSON.parse(this.querySelector('[data-dp-sources]').textContent);
        this.cache = new Map();
        this.products = [];
        this.rendered = 0;
        this.requestId = 0;
        this.count = null;
        this.gender = null;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.renderNextBatch();
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this.sentinel);
        this.querySelectorAll('[data-dp-count]').forEach((button) => button.addEventListener('click', () => this.selectCount(button)));
        this.querySelectorAll('[data-dp-gender]').forEach((button) => button.addEventListener('click', () => this.selectGender(button)));
        this.figureNext.addEventListener('click', () => this.continueFromCount());
        this.genderNext.addEventListener('click', () => this.continueFromGender());
        this.querySelectorAll('[data-dp-back]').forEach((button) => button.addEventListener('click', () => this.goBack()));
        this.querySelectorAll('[data-dp-restart]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.updateProgress('figures');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      selectCount(button) {
        this.count = button.dataset.dpCount;
        this.gender = null;
        this.querySelectorAll('[data-dp-count]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, true);
        this.setContinueState(this.genderNext, false);
      }

      continueFromCount() {
        if (!this.count) return;
        if (this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
        } else {
          this.showProducts(this.count);
        }
      }

      selectGender(button) {
        this.gender = button.dataset.dpGender;
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.setContinueState(this.genderNext, true);
      }

      continueFromGender() {
        if (!this.gender) return;
        this.showProducts(this.gender);
      }

      setContinueState(button, enabled) {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
        button.classList.toggle('is-ready', enabled);
      }

      async showProducts(group) {
        this.showPanel('design');
        this.updateProgress('design');
        this.showSkeletons();
        const requestId = ++this.requestId;
        try {
          const products = await this.getProducts(group);
          if (requestId !== this.requestId) return;
          this.products = products;
          this.rendered = 0;
          this.productGrid.replaceChildren();
          this.resultCount.textContent = products.length
            ? this.dataset.foundTemplate.replace('__COUNT__', products.length)
            : this.dataset.emptyLabel;
          this.renderNextBatch();
        } catch (error) {
          if (requestId !== this.requestId) return;
          this.productGrid.replaceChildren();
          this.resultCount.textContent = this.dataset.errorLabel;
        }
      }

      async getProducts(group) {
        if (this.cache.has(group)) return this.cache.get(group);
        const source = this.sources[group];
        if (!source?.url) return [];
        const separator = source.url.includes('?') ? '&' : '?';
        const response = await fetch(`${source.url}/products.json${separator}limit=250`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
        const payload = await response.json();
        const products = (payload.products || []).filter((product) => this.matchesFigureCount(product, source.mode));
        this.cache.set(group, products);
        return products;
      }

      matchesFigureCount(product, mode) {
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
        const normalized = tags.map((tag) => String(tag).trim().toLocaleLowerCase('tr'));
        const countTags = ['ikili', 'üçlü', 'dörtlü', 'beşli', 'altılı', 'yedili', '7li'];
        if (mode === 'single') return !normalized.some((tag) => countTags.includes(tag));
        const wanted = {
          2: ['ikili'],
          3: ['üçlü'],
          4: ['dörtlü'],
          5: ['beşli'],
          6: ['altılı'],
          7: ['yedili', '7li']
        };
        return (wanted[mode] || []).some((tag) => normalized.includes(tag));
      }

      showSkeletons() {
        this.products = [];
        this.rendered = 0;
        this.resultCount.textContent = this.dataset.loadingLabel;
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < 6; index += 1) {
          const skeleton = document.createElement('span');
          skeleton.className = 'dp-guided-order__product is-skeleton';
          skeleton.setAttribute('aria-hidden', 'true');
          fragment.append(skeleton);
        }
        this.productGrid.replaceChildren(fragment);
      }

      renderNextBatch() {
        if (this.rendered >= this.products.length) return;
        const batchSize = window.matchMedia('(min-width: 990px)').matches ? 16 : 12;
        const next = this.products.slice(this.rendered, this.rendered + batchSize);
        const fragment = document.createDocumentFragment();
        next.forEach((product, index) => {
          const absoluteIndex = this.rendered + index;
          fragment.append(this.createProductCard(product, absoluteIndex === 0, absoluteIndex < 4));
        });
        this.productGrid.append(fragment);
        this.rendered += next.length;
      }

      createProductCard(product, popular, priority) {
        const card = this.productTemplate.content.firstElementChild.cloneNode(true);
        const image = card.querySelector('img');
        const imageSource = product.images?.[0]?.src || product.image?.src;
        card.href = `${window.Shopify?.routes?.root || '/'}products/${product.handle}`;
        card.querySelector('[data-dp-card-title]').textContent = product.title;
        card.querySelector('[data-dp-card-choose]').textContent = this.dataset.chooseLabel;
        card.querySelector('[data-dp-card-price]').textContent = this.formatPrice(product);
        if (imageSource) {
          const imageUrl = new URL(imageSource, window.location.origin);
          imageUrl.searchParams.set('width', '480');
          image.src = imageUrl.toString();
          image.alt = product.images?.[0]?.alt || product.title;
          image.loading = priority ? 'eager' : 'lazy';
          if (priority) image.fetchPriority = 'high';
        } else {
          image.remove();
        }
        if (popular) {
          const badge = card.querySelector('[data-dp-card-popular]');
          badge.textContent = this.dataset.popularLabel;
          badge.hidden = false;
        }
        return card;
      }

      formatPrice(product) {
        const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
        const value = Number(variant?.price || 0);
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currency,
          maximumFractionDigits: value % 1 === 0 ? 0 : 2
        }).format(value);
      }

      goBack() {
        const current = this.panels.find((panel) => !panel.hidden)?.dataset.dpPanel;
        if (current === 'design' && this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
          return;
        }
        this.showPanel('figures');
        this.updateProgress('figures');
      }

      reset() {
        this.requestId += 1;
        this.count = null;
        this.gender = null;
        this.querySelectorAll('[aria-pressed]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, false);
        this.setContinueState(this.genderNext, false);
        this.showPanel('figures');
        this.updateProgress('figures');
      }

      showPanel(name) {
        const update = () => {
          this.panels.forEach((panel) => { panel.hidden = panel.dataset.dpPanel !== name; });
        };
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reduceMotion) document.startViewTransition(update);
        else update();
        window.setTimeout(() => {
          const heading = this.querySelector(`[data-dp-panel="${name}"] h2`);
          heading?.focus({ preventScroll: true });
          this.querySelector('[data-dp-panel]:not([hidden])')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }, reduceMotion ? 0 : 180);
      }

      updateProgress(current) {
        const hasGender = this.count === '1' || this.count === null;
        this.conditionalStep.hidden = !hasGender;
        const visible = this.progressItems.filter((item) => !item.hidden);
        this.progress.style.setProperty('--dp-visible-steps', visible.length);
        const currentIndex = Math.max(0, visible.findIndex((item) => item.dataset.dpProgressItem === current));
        visible.forEach((item, index) => {
          item.classList.toggle('is-complete', index < currentIndex);
          if (index === currentIndex) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
          item.querySelector(':scope > span').textContent = index + 1;
        });
        this.stepStatus.textContent = `${this.dataset.stepWord} ${currentIndex + 1} / ${visible.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dali-pups-order-builder"]) return;
  try {
    
  class DaliPupsOrderBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.catalogHandles = JSON.parse(this.querySelector('[data-dp-catalog]').textContent);
      this.catalog = {};
      this.productCache = {};
      this.designRequest = 0;
      this.labels = JSON.parse(this.dataset.labels);
      this.formComponent = this.querySelector('product-form-component');
      this.form = this.querySelector('form');
      this.state = { step: 1, figures: null, source: null, product: null, sizeIndex: null, frameIndex: null, size: null, frame: null, variant: null };
      this.refs = {
        designs: this.querySelector('[data-dp-designs]'),
        empty: this.querySelector('[data-dp-empty]'),
        figureGrid: this.querySelector('.dp-builder__figure-grid'),
        figureError: this.querySelector('[data-dp-figure-error]'),
        selectedDesign: this.querySelector('[data-dp-selected-design]'),
        sizes: this.querySelector('[data-dp-sizes]'),
        frames: this.querySelector('[data-dp-frames]'),
        price: this.querySelector('[data-dp-price]'),
        stock: this.querySelector('[data-dp-stock]'),
        next: this.querySelector('[data-dp-next]'),
        add: this.querySelector('[ref="addToCartButton"]'),
        photo: this.querySelector('[data-dp-photo]'),
        photoNow: this.querySelector('[data-dp-photo-now]'),
        fileName: this.querySelector('[data-dp-file-name]'),
        error: this.querySelector('[data-dp-form-error]')
      };
      this.lockMobileFirstScreen();
      this.addEventListener('click', this.onClick);
      this.refs.photo.addEventListener('change', this.onPhotoChange);
      this.form.addEventListener('submit', this.onSubmit);
    }

    setLockedStyles(element, styles) {
      if (!element) return;
      Object.entries(styles).forEach(([property, value]) => {
        element.style.setProperty(property, value, 'important');
      });
    }

    lockMobileFirstScreen() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const apply = (selector, styles) => this.querySelectorAll(selector).forEach((element) => this.setLockedStyles(element, styles));
      this.setLockedStyles(this.querySelector('.dp-builder__progress'), {
        display: 'grid',
        gap: '12px',
        'grid-template-columns': 'repeat(2, minmax(0, 1fr))',
        margin: '0 0 18px',
        padding: '0'
      });
      apply('.dp-builder__progress li', {
        'align-items': 'center',
        'border-bottom': '1px solid #e8ddca',
        color: '#7a746a',
        display: 'flex',
        font: "700 0.72rem/1 system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        gap: '7px',
        'min-height': '34px',
        padding: '0 2px 9px'
      });
      apply('.dp-builder__progress-number', {
        'align-items': 'center',
        background: '#f1eadf',
        'border-radius': '50%',
        color: '#8a8073',
        display: 'inline-flex',
        flex: '0 0 24px',
        height: '24px',
        'justify-content': 'center',
        width: '24px'
      });
      apply('.dp-builder__progress-label', { display: 'block', 'white-space': 'nowrap' });
      apply(".dp-builder__progress li[aria-current='step']", { 'border-color': '#b88731', color: '#102944' });
      apply(".dp-builder__progress li[aria-current='step'] .dp-builder__progress-number", { background: '#b88731', color: '#fff' });
      this.setLockedStyles(this.refs.figureGrid, {
        display: 'flex',
        'flex-wrap': 'wrap',
        gap: '9px',
        'justify-content': 'center'
      });
      apply('[data-dp-figure]', {
        '-webkit-appearance': 'none',
        appearance: 'none',
        'align-items': 'center',
        background: '#fffefa',
        border: '1px solid #e2d3bf',
        'border-radius': '14px',
        'box-shadow': 'none',
        'box-sizing': 'border-box',
        color: '#102944',
        cursor: 'pointer',
        display: 'flex',
        flex: '0 0 calc((100% - 27px) / 4)',
        'flex-direction': 'column',
        'font-family': "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        'justify-content': 'center',
        'max-width': 'none',
        'min-height': '62px',
        padding: '7px 4px',
        position: 'relative',
        'text-align': 'center'
      });
      apply('[data-dp-figure] strong', {
        color: '#102944',
        display: 'block',
        'font-family': 'Georgia, serif',
        'font-size': '1.12rem',
        'font-weight': '700',
        'line-height': '1'
      });
      apply('[data-dp-figure] > span', {
        color: '#526176',
        display: 'block',
        font: "500 0.66rem/1.15 system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        margin: '4px 0 0'
      });
      this.setLockedStyles(this.querySelector('[data-dp-start]'), {
        '-webkit-appearance': 'none',
        appearance: 'none',
        'align-items': 'center',
        background: 'linear-gradient(112deg, #ebcf79 0%, #d5a33d 42%, #b77714 74%, #dfb858 100%)',
        border: '1px solid #aa7119',
        'border-radius': '15px',
        'box-shadow': '0 12px 24px #9f681a40, inset 0 1px 0 #fff5ce99',
        'box-sizing': 'border-box',
        color: '#102944',
        display: 'flex',
        font: "800 0.92rem/1.1 system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        'justify-content': 'center',
        margin: '18px 0 0',
        'min-height': '60px',
        padding: '0 54px',
        position: 'relative',
        width: '100%'
      });
      this.setLockedStyles(this.querySelector('[data-dp-start] span[aria-hidden="true"]'), {
        'align-items': 'center',
        background: '#102944',
        'border-radius': '50%',
        color: '#fff',
        display: 'inline-flex',
        height: '27px',
        'justify-content': 'center',
        position: 'absolute',
        right: '15px',
        width: '27px'
      });
      this.setLockedStyles(this.querySelector('.dp-builder__trust'), {
        display: 'flex',
        'flex-wrap': 'wrap',
        gap: '7px',
        'justify-content': 'center',
        margin: '16px 0 0',
        padding: '0'
      });
      apply('.dp-builder__trust-item', {
        'align-items': 'center',
        background: '#fffefa',
        border: '1px solid #eadfce',
        'border-radius': '999px',
        'box-sizing': 'border-box',
        color: '#526176',
        display: 'inline-flex',
        font: "500 0.65rem/1.2 system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        gap: '4px',
        'min-height': '32px',
        padding: '6px 9px'
      });
      apply('.dp-builder__trust-item > span', {
        background: 'transparent',
        border: '0',
        color: '#b88731',
        display: 'inline',
        'font-weight': '800',
        'min-height': '0',
        padding: '0'
      });
    }

    onClick = (event) => {
      const figure = event.target.closest('[data-dp-figure]');
      const gender = event.target.closest('[data-dp-gender]');
      const design = event.target.closest('[data-dp-design]');
      const choice = event.target.closest('[data-dp-choice]');
      const back = event.target.closest('[data-dp-back]');
      const next = event.target.closest('[data-dp-next]');
      const start = event.target.closest('[data-dp-start]');
      if (figure) this.selectFigures(Number(figure.dataset.dpFigure));
      if (gender) this.selectGender(gender.dataset.dpGender);
      if (design) this.selectDesign(design.dataset.dpDesign);
      if (choice) this.selectOption(choice.dataset.dpChoice, choice.dataset.dpValue);
      if (back) this.changeStep(Number(back.dataset.dpBack));
      if (next && !next.disabled) this.changeStep(5);
      if (start) this.startOrder();
    };

    selectFigures(count) {
      this.state.figures = count;
      this.refs.figureError.textContent = '';
      this.refs.figureGrid.removeAttribute('aria-invalid');
      this.querySelectorAll('[data-dp-figure]').forEach((button) => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.dpFigure) === count));
      });
      this.setProperty('figures', String(count));
      if (count === 1) {
        this.changeStep(2);
      } else {
        this.state.source = String(count);
        this.renderDesigns();
        this.changeStep(3);
      }
    }

    startOrder() {
      if (this.state.figures) return;
      this.refs.figureError.textContent = this.labels.figureRequired;
      this.refs.figureGrid.setAttribute('aria-invalid', 'true');
      this.querySelector('[data-dp-figure="1"]').focus({ preventScroll: true });
    }

    selectGender(source) {
      this.state.source = source;
      this.querySelectorAll('[data-dp-gender]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.dpGender === source));
      });
      this.renderDesigns();
      this.changeStep(3);
    }

    async renderDesigns() {
      const request = ++this.designRequest;
      const source = this.state.source;
      const handles = this.catalogHandles[source] || [];
      this.refs.designs.replaceChildren();
      this.refs.empty.hidden = true;
      this.refs.designs.setAttribute('aria-busy', 'true');
      const products = (await Promise.all(handles.map((handle) => this.fetchProduct(handle)))).filter(Boolean);
      if (request !== this.designRequest || this.state.source !== source) return;
      this.catalog[source] = products;
      this.refs.empty.hidden = products.length === 0;
      products.forEach((product, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dp-builder__design-card';
        button.dataset.dpDesign = product.id;
        const image = document.createElement('img');
        image.alt = product.title;
        image.decoding = 'async';
        image.loading = index === 0 ? 'eager' : 'lazy';
        if (index === 0) image.fetchPriority = 'high';
        if (product.image) image.src = product.image;
        const title = document.createElement('span');
        title.textContent = product.title;
        button.append(image, title);
        this.refs.designs.append(button);
      });
      this.refs.designs.removeAttribute('aria-busy');
    }

    async fetchProduct(handle) {
      if (this.productCache[handle]) return this.productCache[handle];
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        if (!response.ok) return null;
        const product = await response.json();
        const normalized = {
          id: product.id,
          title: product.title,
          handle: product.handle,
          url: '/products/' + product.handle,
          image: product.featured_image || product.images?.[0] || '',
          variants: product.variants.map((variant) => ({
            id: variant.id,
            available: variant.available,
            price: variant.price,
            compareAtPrice: variant.compare_at_price,
            options: [variant.option1, variant.option2, variant.option3]
          }))
        };
        this.productCache[handle] = normalized;
        return normalized;
      } catch (error) {
        return null;
      }
    }

    selectDesign(productId) {
      const product = (this.catalog[this.state.source] || []).find((item) => String(item.id) === String(productId));
      if (!product) return;
      const selectedCard = this.querySelector('[data-dp-design="' + product.id + '"]');
      if (selectedCard) {
        selectedCard.disabled = true;
        selectedCard.setAttribute('aria-busy', 'true');
      }
      const destination = new URL(product.url, window.location.origin);
      destination.searchParams.set('view', 'dali-pups-golden-canvas');
      window.location.assign(destination.pathname + destination.search);
    }

    setOptionIndexes() {
      const values = [0, 1, 2].map((index) => this.getOptionValues(index));
      const isSizeSet = (items) => ['30x40', '40x60', '70x100'].every((size) => items.some((item) => this.normalize(item).includes(size)));
      this.state.sizeIndex = values.findIndex(isSizeSet);
      if (this.state.sizeIndex < 0) this.state.sizeIndex = 0;
      this.state.frameIndex = values.findIndex((items, index) => index !== this.state.sizeIndex && items.length > 1);
      if (this.state.frameIndex < 0) this.state.frameIndex = this.state.sizeIndex === 0 ? 1 : 0;
    }

    setDefaultOptions() {
      this.state.size = this.getOptionValues(this.state.sizeIndex)[0] || null;
      this.state.frame = this.getOptionValues(this.state.frameIndex)[0] || null;
    }

    getOptionValues(index) {
      return [...new Set(this.state.product.variants.map((variant) => variant.options[index]).filter(Boolean))];
    }

    normalize(value) {
      return String(value || '').toLocaleLowerCase('tr').replaceAll('×', 'x').replaceAll(' ', '');
    }

    sizeMeta(value) {
      const normalized = this.normalize(value);
      if (normalized.includes('30x40')) return { title: this.labels.compact, detail: '30×40 cm' };
      if (normalized.includes('40x60')) return { title: this.labels.standard, detail: '40×60 cm' };
      if (normalized.includes('70x100')) return { title: this.labels.majestic, detail: '70×100 cm' };
      return { title: value, detail: '' };
    }

    frameMeta(value) {
      return this.isGoldFrame(value) ? { title: this.labels.goldFrame, detail: '' } : { title: this.labels.unframed, detail: '' };
    }

    isGoldFrame(value) {
      const normalized = this.normalize(value);
      return normalized.includes('evet') || normalized.includes('altın') || normalized.includes('altin') || normalized.includes('gold');
    }

    renderSelectedDesign() {
      this.refs.selectedDesign.replaceChildren();
      const image = document.createElement('img');
      image.src = this.state.product.image;
      image.alt = this.state.product.title;
      image.decoding = 'async';
      const copy = document.createElement('div');
      const label = document.createElement('p');
      label.textContent = this.labels.price;
      const title = document.createElement('strong');
      title.textContent = this.state.product.title;
      copy.append(label, title);
      this.refs.selectedDesign.append(image, copy);
    }

    renderOptions() {
      this.renderOptionSet(this.refs.sizes, this.getOptionValues(this.state.sizeIndex), 'size');
      this.renderOptionSet(this.refs.frames, this.getOptionValues(this.state.frameIndex), 'frame');
    }

    renderOptionSet(container, values, kind) {
      container.replaceChildren();
      values.forEach((value) => {
        const button = document.createElement('button');
        const selected = this.state[kind] === value;
        button.type = 'button';
        button.className = 'dp-builder__choice dp-builder__choice--' + kind;
        if (kind === 'frame' && this.isGoldFrame(value)) button.classList.add('dp-builder__choice--gold');
        button.dataset.dpChoice = kind;
        button.dataset.dpValue = value;
        button.setAttribute('aria-pressed', String(selected));
        const meta = kind === 'size' ? this.sizeMeta(value) : this.frameMeta(value);
        const title = document.createElement('strong');
        title.textContent = meta.title;
        const detail = document.createElement('span');
        detail.textContent = meta.detail;
        button.append(title);
        if (meta.detail) button.append(detail);
        button.disabled = !this.isOptionAvailable(kind, value);
        container.append(button);
      });
    }

    isOptionAvailable(kind, value) {
      const size = kind === 'size' ? value : this.state.size;
      const frame = kind === 'frame' ? value : this.state.frame;
      return this.state.product.variants.some((variant) => {
        return variant.available && variant.options[this.state.sizeIndex] === size && variant.options[this.state.frameIndex] === frame;
      });
    }

    selectOption(kind, value) {
      if (!this.isOptionAvailable(kind, value)) return;
      this.state[kind] = value;
      this.renderOptions();
      this.updateVariant();
    }

    updateVariant() {
      const variant = this.state.product.variants.find((item) => {
        return item.options[this.state.sizeIndex] === this.state.size && item.options[this.state.frameIndex] === this.state.frame;
      });
      this.state.variant = variant || null;
      this.setProperty('size', this.state.size || '');
      this.setProperty('frame', this.state.frame || '');
      const variantInput = this.querySelector('[ref="variantId"]');
      if (variant) variantInput.value = variant.id;
      this.refs.price.textContent = variant ? this.formatPrice(variant.price) : '—';
      const available = Boolean(variant && variant.available);
      this.refs.stock.textContent = available ? this.labels.available : this.labels.soldOut;
      this.refs.stock.dataset.state = available ? 'available' : 'soldout';
      this.refs.next.disabled = !available;
      this.refs.add.disabled = !available;
    }

    formatPrice(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'tr-TR', {
          style: 'currency',
          currency: this.dataset.currency || 'TRY',
          maximumFractionDigits: 2
        }).format(Number(cents) / 100);
      } catch (error) {
        return (Number(cents) / 100).toFixed(2);
      }
    }

    setProperty(name, value) {
      const input = this.querySelector('[data-dp-property="' + name + '"]');
      if (input) input.value = value;
    }

    changeStep(step) {
      this.state.step = step;
      this.querySelectorAll('[data-dp-panel]').forEach((panel) => {
        panel.hidden = Number(panel.dataset.dpPanel) !== step;
      });
      const progress = step === 2 ? 1 : Math.min(step - 1, 4);
      this.querySelectorAll('[data-dp-progress]').forEach((item) => {
        if (Number(item.dataset.dpProgress) === progress) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
      });
      this.lockMobileFirstScreen();
      const heading = this.querySelector('[data-dp-panel="' + step + '"] h2');
      requestAnimationFrame(() => heading && heading.focus({ preventScroll: false }));
    }

    onPhotoChange = () => {
      this.refs.fileName.textContent = this.refs.photo.files[0] ? this.refs.photo.files[0].name : '';
      this.refs.error.textContent = '';
    };

    onSubmit = (event) => {
      this.refs.error.textContent = '';
      if (!this.state.variant || !this.state.variant.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (this.refs.photoNow.checked && !this.refs.photo.files.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.refs.error.textContent = this.labels.required;
        this.refs.photo.focus();
      }
    };
  }

  if (!customElements.get('dp-order-builder')) {
    customElements.define('dp-order-builder', DaliPupsOrderBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
